import { useState } from "react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsCard from "@/components/feature/NewsCard";
import Pagination from "@/components/feature/Pagination";

const PAGE_SIZE = 6;

export default function NewsPage() {
  const [page, setPage] = useState(1);

  usePageMeta({
    title: "影视资讯专题 - CC视频",
    description:
      "CC视频影视资讯专题，聚合新片速递、热剧观察、行业动态与幕后揭秘等最新影视资讯，帮你掌握影视圈动态。",
    keywords: "影视资讯,CC视频资讯,新片速递,热剧观察,行业动态,幕后揭秘",
  });

  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const pageItems = newsList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handlePageChange = (next: number) => {
    setPage(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <div className="mt-4 mb-8">
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          影视资讯专题
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-3xl">
          聚焦最新影视动态，从新片速递到行业观察，为你梳理值得关注的影视资讯与幕后故事。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {pageItems.map((news) => (
          <NewsCard key={news.id} news={news} variant="block" />
        ))}
      </div>

      <Pagination current={page} total={totalPages} onChange={handlePageChange} />
    </div>
  );
}